import Select from 'react-select-2';
import type { ReactElement, VoidFunctionComponent } from 'react';

import { selectOptionFactory } from '../../../../../../utils';
import { BUTTON_TYPE, TooltipButton } from '../../../../../generic';
import Text from '../../../../../generic/Text';
import RemoveDomainConfirmationModal from '../RemoveDomainConfirmationModal';
import type { SelectOption } from '../../../../../../types';

import { ClaimDomainModal } from './ClaimDomainModal';
import { useClaimDomain } from './hooks';

/**
 * This component displays a 'Sign in with Google' button that allows users to claim their domain.
 */
const ClaimDomain: VoidFunctionComponent = () => {
  const {
    canClaimDomain,
    toggleIsClaimDomainModalOpen,
    onChangeDomains,
    relevantDomains,
    isClaimDomainModalOpen,
    clearQueryParams,
    isRemoveDomainModalOpen,
    domainToRemove,
    setDomainToRemove,
    toggleIsRemoveDomainModalOpen,
    onConfirmRemoveDomain,
  } = useClaimDomain();

  const claimNewDomainButton = (
    <TooltipButton
      id="claim-new-domain"
      type={BUTTON_TYPE.SECONDARY}
      isDisabled={!canClaimDomain}
      onClick={toggleIsClaimDomainModalOpen}
      showTooltip={!canClaimDomain}
      tooltip="Please save your changes to claim a domain."
    >
      Claim New Domain
    </TooltipButton>
  );

  let body: ReactElement;
  if (relevantDomains.length > 0) {
    body = (
      <>
        <Select
          components={{ DropdownIndicator: null }}
          value={relevantDomains.map(({ domain }) => selectOptionFactory(domain))}
          inputValue=""
          onChange={(value) => onChangeDomains(value as SelectOption[])}
          menuIsOpen={false}
          isClearable={false}
          isSearchable={false}
          isMulti
        />
        <div className="margin-top-sm">{claimNewDomainButton}</div>
      </>
    );
  } else {
    body = claimNewDomainButton;
  }

  return (
    <>
      <Text.H3>Redirect Email Domains</Text.H3>
      <div className="gray-rounded-box margin-top-sm">
        <Text.Paragraph>
          When your organization has claimed a domain for Google Workspace, all that a member of your company needs to
          do to access your organization in FOSSA is click the Google button on the sign in page. FOSSA will redirect
          users with your claimed email domains to sign in with Google. This will also prevent members of your company
          from creating duplicate organizations.
        </Text.Paragraph>
        {body}
      </div>
      <ClaimDomainModal
        isOpen={isClaimDomainModalOpen}
        onHide={() => {
          toggleIsClaimDomainModalOpen();
          clearQueryParams();
        }}
      />
      <RemoveDomainConfirmationModal
        isOpen={isRemoveDomainModalOpen}
        domainToRemove={domainToRemove}
        onHide={() => {
          toggleIsRemoveDomainModalOpen();
          setDomainToRemove(null);
        }}
        onConfirm={onConfirmRemoveDomain}
      />
    </>
  );
};

export default ClaimDomain;
